import React from 'react';

/*
    WebAura Logo
    - Stylized "W" inside circular gradient.
    - Aura glow using filter + soft radial highlight.
    - Accessible (role + title).
    - Customizable size via className prop.
*/
const Logo = ({ className = "w-12 h-12", title = "WebAura" }) => {
    return (
        <svg
            className={className}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            <title>{title}</title>
            <defs>
                <linearGradient id="wa_grad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#0a1f44" />
                    <stop offset="100%" stopColor="#1e3a5f" />
                </linearGradient>
                <linearGradient id="wa_stroke" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#f59e0b" />
                    <stop offset="100%" stopColor="#ea580c" />
                </linearGradient>
                <filter id="wa_glow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
                    <feColorMatrix
                        in="blur"
                        type="matrix"
                        values="0 0 0 0 1  0 0 0 0 0.73  0 0 0 0 0.25  0 0 0 0.35 0"
                    />
                </filter>
                <radialGradient id="wa_highlight" cx="0.35" cy="0.35" r="0.8">
                    <stop offset="0%" stopColor="rgba(255,255,255,0.45)" />
                    <stop offset="60%" stopColor="rgba(255,255,255,0.05)" />
                    <stop offset="100%" stopColor="rgba(255,255,255,0)" />
                </radialGradient>
            </defs>

            {/* Background circle */}
            <circle cx="50" cy="50" r="48" fill="url(#wa_grad)" />
            <circle cx="50" cy="50" r="48" fill="url(#wa_highlight)" />

            {/* Stylized W: four strokes forming angled legs + inner joins */}
            <g stroke="url(#wa_stroke)" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" fill="none" filter="url(#wa_glow)">
                <path d="M20 28 L33 72" />
                <path d="M33 72 L50 40" />
                <path d="M50 40 L67 72" />
                <path d="M67 72 L80 28" />
            </g>

            {/* Inner crisp stroke overlay for sharper edges */}
            <g stroke="#fff" strokeOpacity="0.9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                <path d="M20 28 L33 72 L50 40 L67 72 L80 28" />
            </g>

            {/* Accent spark */}
            <circle cx="78" cy="26" r="4" fill="#fcd34d" />
            <circle cx="78" cy="26" r="8" fill="#fcd34d" fillOpacity="0.15" />
        </svg>
    );
};

export default Logo;
